import { createCodeableConcept, medpraxSystem } from '@quromedical/fhir-common';
import type { MedpraxPageResult } from '../external-integrations';

import type { PractitionerQualificationCode } from './schema';

// TODO: Talk to someone about you changing the below to not return undefined
export const mapMedpraxSpecialtyToPractitionerQualification = (
  specialty: MedpraxPageResult,
): PractitionerQualificationCode => {
  const codeableConcept = createCodeableConcept(
    specialty.Code,
    specialty.Description,
    specialty.Description,
    medpraxSystem,
  );

  const qualification: PractitionerQualificationCode = {
    code: codeableConcept,
  };

  return qualification;
};
